import { render, staticRenderFns } from "./AppReleaseFilters.vue?vue&type=template&id=65de225a&"
import script from "./AppReleaseFilters.vue?vue&type=script&lang=js&"
export * from "./AppReleaseFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports